var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 43,
    viewBox: "0 0 32 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3335 14.7812C25.3335 19.9799 21.1585 24.1875 16.0002 24.1875C10.8418 24.1875 6.66683 19.9799 6.66683 14.7812C6.66683 9.58262 10.8418 5.375 16.0002 5.375C21.1585 5.375 25.3335 9.58262 25.3335 14.7812ZM18.6668 29.3189C25.4918 28.0592 30.6668 22.0291 30.6668 14.7812C30.6668 6.61797 24.1002 0 16.0002 0C7.90016 0 1.3335 6.61797 1.3335 14.7812C1.3335 22.0291 6.5085 28.0592 13.3335 29.3189V32.25H10.6668C9.19183 32.25 8.00016 33.451 8.00016 34.9375C8.00016 36.424 9.19183 37.625 10.6668 37.625H13.3335V40.3125C13.3335 41.799 14.5252 43 16.0002 43C17.4752 43 18.6668 41.799 18.6668 40.3125V37.625H21.3335C22.8085 37.625 24.0002 36.424 24.0002 34.9375C24.0002 33.451 22.8085 32.25 21.3335 32.25H18.6668V29.3189Z",
    fill: "#FBC2B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.b55617dbf8fff3871fd04170e98361e2.svg";
export { ForwardRef as ReactComponent };